export function parsePassportInfo(str) {
    const matches = (str || "").match(/^\s*([0-9 №]+)\s*,\s*выдан\s+(\d{2})\.(\d{2}).(\d{4})\s+(.+?)\s*$/);

    if (!matches) {
        return null;
    }

    const seriesNumber = matches[1].replace(/[^0-9]/g, '');

    if (10 !== seriesNumber.length) {
        return null;
    }

    return {
        series: seriesNumber.substring(0, 4),
        number: seriesNumber.substring(4),
        when: matches[4] + '-' + matches[3] + '-' + matches[2],
        whom: matches[5],
    }
}
